export default __webpack_public_path__ + "static/media/Vespa.9abe1948.jpg";